import { TrendingDown, TrendingUp } from "lucide-react";

export const Pagination = ({ pagination, fetchdata }) => {
  const handlePageChange = (page) => {
    fetchdata(page);
  };
  return (
    <>
      <div className="pagination">
        {/* Previous */}
        <button
          className="page-btn prev"
          disabled={pagination.current_page === 1}
          onClick={() => handlePageChange(pagination.current_page - 1)}
        >
          <TrendingUp size={16} />
          Previous
        </button>

        {/* Page Numbers */}
        {[...Array(pagination.total_pages)].map((_, index) => {
          const page = index + 1;

          return (
            <button
              key={page}
              className={`page-btn ${
                pagination.current_page === page ? "active" : ""
              }`}
              onClick={() => handlePageChange(page)}
            >
              {page}
            </button>
          );
        })}

        {/* Next */}
        <button
          className="page-btn next"
          disabled={!pagination.has_next}
          onClick={() => handlePageChange(pagination.current_page + 1)}
        >
          Next
          <TrendingUp size={16} />
        </button>
      </div>
    </>
  );
};
